module.exports = __webpack_public_path__ + "img/saas_logo.png";